import { atom } from 'jotai';
import type { CachedFetchLoadInFlight, StoreData } from '@studio/helpers/tsUtils';
import type { Regions } from '@studio/types';

export const regionsAtom = atom<StoreData<Readonly<Regions.Get.Region[]>>>({
  data: [],
  error: undefined,
  hasFetched: false,
  timestamp: 0,
});

export const regionsLoadInFlightAtom = atom<CachedFetchLoadInFlight | null>(null);
